import { TResponseType } from '@@types/base';
import instance from '@apis/instance';
import { TCheckSignup, TSignupUser } from '@@types/auth';
import { IMyInfo } from 'interfaces/my-info';
import { invalidateGetResponse } from 'utils/common';

const BASE_AUTH_URI = '/auth';

const INFO_URL = `${BASE_AUTH_URI}/my-info`;
const fetchUserInfo = () =>
  invalidateGetResponse<IMyInfo>({
    url: INFO_URL,
    options: {
      headers: { notInterceptor: true },
    },
  });

const MONEY_URL = `${INFO_URL}/money`;
const fetchUserMoney = () =>
  invalidateGetResponse<{ money: IMyInfo['money'] }>({
    url: MONEY_URL,
    options: {
      headers: { noInterceptor: true },
    },
  });

const CHECK_SIGNUP_URL = `${BASE_AUTH_URI}/signup/check`;
const checkSignupStatus = (signupData: TCheckSignup) =>
  instance.post(`${CHECK_SIGNUP_URL}/${signupData.provider}`, signupData, {
    headers: { notInterceptor: true },
  });

const SIGN_UP_URL = `${BASE_AUTH_URI}/signup`;
const signUp = (userData: TSignupUser) =>
  instance.post(`${SIGN_UP_URL}/${userData.provider}`, userData, {
    headers: { notInterceptor: true },
  });

const FRIENDSHIP_URL = `${BASE_AUTH_URI}/friendship`;
const checkFriendshipStatus = () =>
  instance.get<{ code: number }>(`${FRIENDSHIP_URL}/line`);

export default {
  fetchUserInfo,
  fetchUserMoney,
  checkSignupStatus,
  signUp,
  checkFriendshipStatus,
};
